import create from 'zustand';

export type useApiLoaderStoreType = {
  loaderJobs: any[];
  showLoader: (param: boolean) => void;
  validatedLoaderjobs: () => void;
};
export const useApiLoaderStore = create<useApiLoaderStoreType>((set) => {
  return {
    loaderJobs: [],

    showLoader: (param: boolean) => {
      set((state) => {
        if (param) {
          state.loaderJobs.push({ time: new Date().getMilliseconds() });
        } else {
          if (state.loaderJobs.length > 0) {
            state.loaderJobs.shift();
          }
        }
        setTimeout(() => {
          state.validatedLoaderjobs();
        }, 60000);
        return {
          loaderJobs: state.loaderJobs,
        };
      });
    },
    validatedLoaderjobs: () => {
      set((state) => {
        if (
          state.loaderJobs.length > 0 &&
          state.loaderJobs[state.loaderJobs.length - 1].time <
            new Date().getMilliseconds() - 60000
        ) {
          return {
            loaderJobs: [],
          };
        } else {
          return {
            loaderJobs: state.loaderJobs,
          };
        }
      });
    },
  };
});
